import React from 'react';
import classNames from 'classnames';
import { observer } from 'mobx-react';
import { Text, Stack, Icon } from '@servicetitan/design-system';
import { ClientDataStore } from 'src/core/stores/client-data.store';
import { RouteParams } from '../signature-routes';
import { RouteComponentProps, withRouter } from 'react-router';
import { lazyInject } from 'src/signature/ioc';
import styles from './visit-assistant-header.less';

interface VisitAssistantHeaderProps extends RouteComponentProps<RouteParams> {
    showTenantName?: boolean;
    tenantName?: string;
    isHomePage?: boolean;
    backLinkUrl?: string;
    secondaryComponent?: React.ReactComponentElement<any>;
}

@observer
class VisitAssistantHeaderUnwrapped extends React.Component<VisitAssistantHeaderProps> {
    @lazyInject(ClientDataStore) clientData!: ClientDataStore;

    handleClickBackLink = () => {
        const { history, match, backLinkUrl } = this.props;
        const { visitActionId } = match.params;

        if (backLinkUrl) {
            history.push(backLinkUrl);
        } else {
            history.push(`/signatures/${visitActionId}`);
        }
    };

    render() {
        const { showTenantName, tenantName, isHomePage, secondaryComponent } = this.props;

        let primaryText;
        let secondaryText;

        if (showTenantName) {
            const portalData = this.clientData.portalData;
            const portalBrandOfficialName =
                portalData && portalData.brandData && portalData.brandData.officialName;
            primaryText = tenantName || portalBrandOfficialName || '';
            secondaryText = 'Visit Assistant';
        } else {
            primaryText = 'Visit Assistant';
        }

        return (
            <Stack wrap="nowrap" alignItems="center" className={styles.header}>
                <Stack.Item>
                    {!isHomePage && (
                        <Icon
                            name="keyboard_arrow_left"
                            className="m-r-half cursor-pointer"
                            size={28}
                            onClick={this.handleClickBackLink}
                        />
                    )}
                </Stack.Item>
                <Stack.Item shrink={1}>
                    <Text
                        bold
                        size={4}
                        onClick={!isHomePage ? this.handleClickBackLink : null}
                        className={classNames('t-truncate', { 'cursor-pointer': !isHomePage })}
                    >
                        {primaryText}
                    </Text>
                </Stack.Item>
                <div className="space-filler" />
                <Stack.Item>
                    <Text size={3} className="c-neutral-90 m-r-3">
                        {secondaryText}
                    </Text>
                </Stack.Item>
                <Stack.Item>{Boolean(secondaryComponent) && secondaryComponent}</Stack.Item>
            </Stack>
        );
    }
}

export const VisitAssistantHeader = withRouter(VisitAssistantHeaderUnwrapped);
